import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createAction, createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';
export var key = 'page';

//
// Initial state
//
var initialState = {
  slug: null,
  data: null,
  loaded: false
};

//
// Actions
//
export var actions = {
  setSlug: createAction('Page: setSlug', function (slug) {
    return {
      slug: slug
    };
  }),
  setData: createAction('Page: setData', function (data) {
    return {
      data: data
    };
  }),
  setLoaded: createAction('Page: setLoaded', function (loaded) {
    return {
      loaded: loaded
    };
  })
};

//
// Reducer
//
export var reducer = createReducer(_defineProperty(_defineProperty(_defineProperty({}, actions.setSlug, function (state, _ref) {
  var slug = _ref.slug;
  return Immutable["static"].merge(state, {
    slug: slug
  });
}), actions.setData, function (state, _ref2) {
  var data = _ref2.data;
  return Immutable["static"].merge(state, {
    data: data
  });
}), actions.setLoaded, function (state, _ref3) {
  var loaded = _ref3.loaded;
  return Immutable["static"].merge(state, {
    loaded: loaded
  });
}), initialState);

//
// Selectors
//

var root = function root(state) {
  return state[key];
};
var isLoaded = function isLoaded(state) {
  return root(state).loaded;
};
var slug = function slug(state) {
  return root(state).slug;
};
var data = function data(state) {
  return root(state).data;
};
export var selectors = {
  isLoaded: isLoaded,
  slug: slug,
  data: data
};